<template>
  <div>
    <v-form ref="pressureForm">
      <v-row>
        <v-col cols="12" md="6" lg="6" sm="12">
          <v-row no-gutters>
            <v-col>
              <v-text-field label="САД"
                            filled
                            outlined
                            v-model="pressure.sad"
                            :rules="validation.pressure"
              >
              </v-text-field>
              <v-slider v-model="pressure.sad" min="0" max="310"></v-slider>
            </v-col>
            <v-col>
              <span class="after-ad">мм.рт.ст.</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" lg="6" sm="12">
          <v-row no-gutters>
            <v-col>
              <v-text-field label="ДАД"
                            filled
                            outlined
                            v-model="pressure.dad"
                            :rules="validation.pressure"
              >
              </v-text-field>
              <v-slider v-model="pressure.dad" min="0" max="310"></v-slider>
            </v-col>
            <v-col>
              <span class="after-ad">мм.рт.ст.</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="pressureOk()">
      <v-col align="start">
        <v-btn color="primary" @click="goNext()">Применить</v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Pressure',
  data: () => (
    {
      validation: {
        pressure: [
          (value) => {
            return !!value || 'Поле обязательно для заполнения'
          },
          (value) => {
            if (value === '' || value === undefined) {
              return true
            }

            let numberPattern = /^[0-9]+$/
            return numberPattern.test(value) || 'Используйте только цифры'
          },
          (value) => {
            if (value > 39 && value < 311) {
              return true
            }
            return 'Указанное значение неприемлемо'
          }
        ]
      },
      isPressureOk: false,
      pressure: {
        sad: '',
        dad: '',
        degree: ''
      },
      pressureData: {
        specialCases: {
          isolate: {
            sad: { range: [140, false] },
            dad: { range: [false, 89] },
            oper: '&&',
            degree: {
              by: 'sad',
              ranges: {
                none: { range: [false, 129] },
                0: { range: [130, 139] },
                1: { range: [140, 159] },
                2: { range: [160, 179] },
                3: { range: [180, false] }
              }
            }
          },
          dadIsolate: {
            sad: { range: [false, 139] },
            dad: { range: [90, false] },
            oper: '&&',
            degree: {
              by: 'dad',
              ranges: {
                none: { range: [false, 84] },
                0: { range: [85, 89] },
                1: { range: [90, 99] },
                2: { range: [100, 109] },
                3: { range: [110, false] }
              }
            }
          },
        },
        bySad: {
          none: { range: [false, 129] },
          0: { range: [130, 139] },
          1: { range: [140, 159] },
          2: { range: [160, 179] },
          3: { range: [180, false] }
        },
        byDad: {
          none: { range: [false, 84] },
          0: { range: [85, 89] },
          1: { range: [90, 99] },
          2: { range: [100, 109] },
          3: { range: [110, false] }
        }
      }
    }
  ),
  created () {
    this.pressure.sad = typeof this != 'undefined' ? this.$store.state.results.pressure.sad : ''
    this.pressure.dad = typeof this != 'undefined' ? this.$store.state.results.pressure.dad : ''
    this.pressure.degree = typeof this != 'undefined' ? this.$store.state.results.pressure.degree : ''
  },
  activated () {
    console.log('activated');
  },
  methods: {
    pressureOk () {
      let result = this.$refs.pressureForm ? this.$refs.pressureForm.validate() : false
      return result
    },
    goNext () {
      this.pressure.degree = this.calculateDegree()
      this.$emit('pressureIsSet', this.pressure)
    },
    calculateDegree () {
      let keys = Object.keys(this.pressureData.specialCases)
      for (var key in keys) {
        var keyName = keys[key]
        var specialCase = this.pressureData.specialCases[keyName]
        var operation = specialCase.oper
        var sadPart = specialCase.sad.range[0] !== false ? 'this.pressure.sad >= ' + specialCase.sad.range[0] : ''
        sadPart += specialCase.sad.range[1] !== false ? ' this.pressure.sad <= ' + specialCase.sad.range[1] : ''
        var dadPart = specialCase.dad.range[0] !== false ? 'this.pressure.dad >= ' + specialCase.dad.range[0] : ''
        dadPart += specialCase.dad.range[1] !== false ? ' this.pressure.dad <= ' + specialCase.dad.range[1] : ''
        var operationString = sadPart + ' ' + operation + ' ' + dadPart
        var matched = eval(operationString)
        if (matched) {
          let isolateDegreeData = specialCase.degree
          let isolateDegree = ''
          if (isolateDegreeData.by === 'sad') {
            isolateDegree = this.degreeBySad(isolateDegreeData.ranges)
          } else if (isolateDegreeData.by === 'dad') {
            isolateDegree = this.degreeByDad(isolateDegreeData.ranges)
          }
          let result = keyName + '.' + isolateDegree
          return result
        }
      }
      var matchedCases = { bySad: false, byDad: false }

      var bySadDegree = this.degreeBySad(this.pressureData.bySad)
      if (bySadDegree !== false) {
        matchedCases.bySad = bySadDegree
      }
      var byDadDegree = this.degreeByDad(this.pressureData.byDad)
      if (byDadDegree !== false) {
        matchedCases.byDad = byDadDegree
      }

      // keys = Object.keys(this.pressureData.bySad)
      // for (var key in keys) {
      //   var keyName = keys[key]
      //   var sadItem = this.pressureData.bySad[keyName]
      //   var fromPart = sadItem.range[0] !== false ? 'this.pressure.sad >= ' + sadItem.range[0] : false
      //   var toPart = sadItem.range[1] !== false ? 'this.pressure.sad <= ' + sadItem.range[1] : false
      //   var operationString = ''
      //   if (fromPart !== false && toPart !== false) {
      //     operationString = fromPart + ' && ' + toPart
      //   } else {
      //     operationString = fromPart === false ?  toPart : fromPart
      //   }
      //   var matched = eval(operationString)
      //   if (matched) {
      //     matchedCases.bySad = keyName
      //   }
      // }

      // keys = Object.keys(this.pressureData.byDad)
      // for (var key in keys) {
      //   var keyName = keys[key]
      //   var dadItem = this.pressureData.byDad[keyName]
      //   var fromPart = dadItem.range[0] !== false ? 'this.pressure.dad >= ' + dadItem.range[0] : false
      //   var toPart = dadItem.range[1] !== false ? 'this.pressure.dad <= ' + dadItem.range[1] : false
      //   var operationString = ''
      //   if (fromPart !== false && toPart !== false) {
      //       operationString = fromPart + ' && ' + toPart
      //   } else {
      //       operationString = fromPart === false ?  toPart : fromPart
      //   }
      //   var matched = eval(operationString)
      //   if (matched) {
      //       matchedCases.byDad = keyName
      //   }
      // }

      if (matchedCases.bySad == 'none' && matchedCases.byDad == 'none') {
          return matchedCases.bySad
      }
      if (matchedCases.bySad != 'none' && matchedCases.byDad != 'none') {
          return Math.max(matchedCases.bySad, matchedCases.byDad)
      }
      return  matchedCases.bySad == 'none' ? matchedCases.byDad : matchedCases.bySad
    },
    degreeBySad(ranges) {
      let keys = Object.keys(ranges)
      for (var key in keys) {
        var keyName = keys[key]
        var sadItem = ranges[keyName]
        var fromPart = sadItem.range[0] !== false ? 'this.pressure.sad >= ' + sadItem.range[0] : false
        var toPart = sadItem.range[1] !== false ? 'this.pressure.sad <= ' + sadItem.range[1] : false
        var operationString = ''
        if (fromPart !== false && toPart !== false) {
            operationString = fromPart + ' && ' + toPart
        } else {
            operationString = fromPart === false ?  toPart : fromPart
        }
        var matched = eval(operationString)
        if (matched) {
          return keyName
        }
      }
      return false
    },
    degreeByDad (ranges) {
      let keys = Object.keys(ranges)
      for (var key in keys) {
        var keyName = keys[key]
        var dadItem = ranges[keyName]
        var fromPart = dadItem.range[0] !== false ? 'this.pressure.dad >= ' + dadItem.range[0] : false
        var toPart = dadItem.range[1] !== false ? 'this.pressure.dad <= ' + dadItem.range[1] : false
        var operationString = ''
        if (fromPart !== false && toPart !== false) {
            operationString = fromPart + ' && ' + toPart
        } else {
            operationString = fromPart === false ?  toPart : fromPart
        }
        var matched = eval(operationString)
        if (matched) {
            return keyName
        }
      }
    }
  }
}
</script>

<style scoped>
  .after-ad {
    display: inline-block;
    line-height: 56px;
    padding-left: 10px;
    font-size: 20px;
    font-weight: 400;
  }
</style>
